import type { ConfigurableServer, Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { generateUniqueWorkspaceName } from '../../workspace/helpers'
import { useExistentWorkspaceNames } from './useExistentWorkspaceNames'

export const useAutomaticWorkspaceName = ({
  workspaceNamePrefix,
  server,
}: {
  workspaceNamePrefix?: string
  server: Optional<ConfigurableServer>
}) => {
  const existentWorkspaceNames = useExistentWorkspaceNames(server)
  return useMemo(() => {
    const baseWorkspaceName = workspaceNamePrefix ?? 'auto'

    return generateUniqueWorkspaceName(
      baseWorkspaceName,
      existentWorkspaceNames,
    )
  }, [existentWorkspaceNames, workspaceNamePrefix])
}
